 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"About":"About","Again~Analysis~Answer~OptionTopic~Practice":"Again~Analysis~Answer~OptionTopic~Practice","Answer":"Answer","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice","Again~Analysis~OptionTopic~Practice":"Again~Analysis~OptionTopic~Practice","Again":"Again","Analysis":"Analysis","OptionTopic":"OptionTopic","Practice":"Practice","AuditionInfo":"AuditionInfo","Index":"Index","MyClass":"MyClass","Audition":"Audition","Chapter":"Chapter","Collect":"Collect","Course":"Course","Details":"Details","Downloadapp":"Downloadapp","Everyday":"Everyday","ForgetPwd~Register":"ForgetPwd~Register","ForgetPwd":"ForgetPwd","Register":"Register","Info":"Info","Information":"Information","Introduce":"Introduce","Login":"Login","ModelPaper":"ModelPaper","Personal":"Personal","Phone":"Phone","Record":"Record","ReportCard":"ReportCard","Result":"Result","Servewx":"Servewx","Teachers":"Teachers","TrueTopic":"TrueTopic","Whole~Wrong":"Whole~Wrong","Whole":"Whole","Wrong":"Wrong","WrongAnalysis":"WrongAnalysis","WrongQuestion":"WrongQuestion","modelPaperdetail":"modelPaperdetail","simulation":"simulation"}[chunkId]||chunkId) + "." + {"About":"40f30a5f","Again~Analysis~Answer~OptionTopic~Practice":"48fe4e24","Answer":"0e5fc52d","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"aab62d86","Again~Analysis~OptionTopic~Practice":"532a9e54","Again":"38ca38d5","Analysis":"447fb418","OptionTopic":"f1b0adb2","Practice":"e4ef7fa1","AuditionInfo":"cd0f8b41","Index":"235ee03a","MyClass":"071f4c22","Audition":"c9ef777e","Chapter":"eb03fbaa","Collect":"a7acdd0b","Course":"3d525b39","Details":"894fca94","Downloadapp":"74db4de6","Everyday":"e8031b51","ForgetPwd~Register":"11300718","ForgetPwd":"bc04eba3","Register":"79e83d4e","Info":"7b5ad84b","Information":"2be179fd","Introduce":"438191db","Login":"4da397b4","ModelPaper":"e4d06165","Personal":"2a2d6027","Phone":"87fd467a","Record":"f5af9f5b","ReportCard":"70abb415","Result":"93be7f56","Servewx":"1adff5b6","Teachers":"cfe0a8e5","TrueTopic":"e0442ae0","Whole~Wrong":"1bb5520a","Whole":"d352d981","Wrong":"7401303c","WrongAnalysis":"8eae0473","WrongQuestion":"eedf974c","modelPaperdetail":"765f07b6","simulation":"33dcd215"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About":1,"Again~Analysis~Answer~OptionTopic~Practice":1,"Answer":1,"Again~Analysis~OptionTopic~Practice":1,"Again":1,"Analysis":1,"OptionTopic":1,"Practice":1,"AuditionInfo":1,"Index":1,"MyClass":1,"Audition":1,"Chapter":1,"Collect":1,"Course":1,"Details":1,"Downloadapp":1,"Everyday":1,"ForgetPwd":1,"Register":1,"Info":1,"Information":1,"Introduce":1,"Login":1,"ModelPaper":1,"Personal":1,"Phone":1,"Record":1,"ReportCard":1,"Result":1,"Servewx":1,"Teachers":1,"TrueTopic":1,"Whole":1,"Wrong":1,"WrongAnalysis":1,"WrongQuestion":1,"modelPaperdetail":1,"simulation":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"About":"About","Again~Analysis~Answer~OptionTopic~Practice":"Again~Analysis~Answer~OptionTopic~Practice","Answer":"Answer","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice","Again~Analysis~OptionTopic~Practice":"Again~Analysis~OptionTopic~Practice","Again":"Again","Analysis":"Analysis","OptionTopic":"OptionTopic","Practice":"Practice","AuditionInfo":"AuditionInfo","Index":"Index","MyClass":"MyClass","Audition":"Audition","Chapter":"Chapter","Collect":"Collect","Course":"Course","Details":"Details","Downloadapp":"Downloadapp","Everyday":"Everyday","ForgetPwd~Register":"ForgetPwd~Register","ForgetPwd":"ForgetPwd","Register":"Register","Info":"Info","Information":"Information","Introduce":"Introduce","Login":"Login","ModelPaper":"ModelPaper","Personal":"Personal","Phone":"Phone","Record":"Record","ReportCard":"ReportCard","Result":"Result","Servewx":"Servewx","Teachers":"Teachers","TrueTopic":"TrueTopic","Whole~Wrong":"Whole~Wrong","Whole":"Whole","Wrong":"Wrong","WrongAnalysis":"WrongAnalysis","WrongQuestion":"WrongQuestion","modelPaperdetail":"modelPaperdetail","simulation":"simulation"}[chunkId]||chunkId) + "." + {"About":"9f2496b3","Again~Analysis~Answer~OptionTopic~Practice":"260fce0b","Answer":"668f0fbf","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"31d6cfe0","Again~Analysis~OptionTopic~Practice":"ebe0fe4e","Again":"841fe557","Analysis":"dfb1ec07","OptionTopic":"a0e35558","Practice":"7c135fb3","AuditionInfo":"ed8ef2b2","Index":"d41d1a09","MyClass":"01d26699","Audition":"1b907e77","Chapter":"503dcb5a","Collect":"f87589ea","Course":"73caa081","Details":"35904cab","Downloadapp":"8ae0f4cf","Everyday":"986c473c","ForgetPwd~Register":"31d6cfe0","ForgetPwd":"aa81f823","Register":"0c65603c","Info":"1748bdfc","Information":"6508b913","Introduce":"0fdeab99","Login":"c859486a","ModelPaper":"72f6e10f","Personal":"4e865301","Phone":"976ffa07","Record":"a58e5135","ReportCard":"be961df3","Result":"1652d2a5","Servewx":"0ad373e6","Teachers":"be2149f2","TrueTopic":"e0d1d5e4","Whole~Wrong":"31d6cfe0","Whole":"86d4c43f","Wrong":"6de6f24e","WrongAnalysis":"bddfdbfd","WrongQuestion":"0a5b81c5","modelPaperdetail":"ad6349d0","simulation":"9bb949ff"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
